import { useState } from 'react'
import { computeSavings, moneyCompact, percentToSpend, SLIDER_DEFAULTS } from './savingsMath'

const sliderThumb = "[&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-[22px] [&::-webkit-slider-thumb]:w-[22px] [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-[#3D6BFF] [&::-webkit-slider-thumb]:shadow-[0_0_0_4px_rgba(61,107,255,.25)] [&::-webkit-slider-thumb]:cursor-pointer [&::-moz-range-thumb]:h-[22px] [&::-moz-range-thumb]:w-[22px] [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-white [&::-moz-range-thumb]:border-2 [&::-moz-range-thumb]:border-[#3D6BFF] [&::-moz-range-thumb]:shadow-[0_0_0_4px_rgba(61,107,255,.25)] [&::-moz-range-thumb]:cursor-pointer"

export default function SavingsCalculator({ onBurnChange }) {
  const [sliderPct, setSliderPct] = useState(SLIDER_DEFAULTS.initial)
  const burn = percentToSpend(sliderPct)
  const { months, todayRange, todayBody, lbPrice } = computeSavings(burn)
  const maxMonth = Math.max(...months.map((m) => m.value))

  function handleInput(e) {
    const nextPct = parseFloat(e.target.value)
    setSliderPct(nextPct)
    onBurnChange?.(percentToSpend(nextPct))
  }

  return (
    <>
      <div className="mt-11">
        <label htmlFor="monthly-spend" className="font-mono text-xs tracking-[0.1em] text-[#5B8CFF] uppercase">What do you spend on tokens per month?</label>
        <div className="mt-2.5 flex flex-col gap-1.5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-5">
          <span className="font-mono text-[clamp(1.8rem,4vw,2.6rem)] leading-none font-semibold tracking-[-0.03em] text-[#5B8CFF]">{moneyCompact(burn)}</span>
        </div>
        <input
          id="monthly-spend"
          name="monthly-spend"
          className={`mt-[18px] w-full cursor-pointer appearance-none rounded-full border-[1.5px] border-[#3D6BFF] outline-none ${sliderThumb}`}
          style={{ height: 10, background: `linear-gradient(90deg,#3D6BFF var(--g-pct,50%),transparent var(--g-pct,50%)),transparent`, '--g-pct': sliderPct + '%' }}
          type="range"
          min={SLIDER_DEFAULTS.min}
          max={SLIDER_DEFAULTS.max}
          step={SLIDER_DEFAULTS.step}
          value={sliderPct}
          onChange={handleInput}
        />
        <p className="mt-3.5 text-[13px] text-[rgba(245,245,243,.45)]">Typical: $1,000&ndash;$3,000 per engineer per month on average startup tooling.</p>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-[18px] sm:grid-cols-2">
        <div className="rounded-[14px] border border-[rgba(245,245,243,.14)] bg-[rgba(255,255,255,.02)] px-6 py-[26px]">
          <div className="font-mono text-[11px] tracking-[0.1em] text-[#FF5A5A] uppercase">Your world today</div>
          <div className="mt-3.5 font-mono text-[clamp(1.6rem,3.2vw,2.2rem)] leading-[1.05] font-semibold tracking-[-0.03em] text-[#F5F5F3]">{todayRange}</div>
          <p className="mt-3 min-h-[3em] text-[0.95rem] leading-[1.5] text-[rgba(245,245,243,.55)]">{todayBody}</p>
          <div className="mt-[22px] flex h-[72px] items-end gap-[5px]" aria-hidden="true">
            {months.map((m, i) => (
              <span
                key={i}
                title={moneyCompact(m.value)}
                className="min-h-2 flex-1 rounded-t-[3px]"
                style={{ height: `${(m.value / maxMonth) * 100}%`, background: m.spike ? '#FF5A5A' : 'rgba(245,245,243,.18)' }}
              />
            ))}
          </div>
          <div className="mt-3 text-center font-mono text-[11px] tracking-[0.04em] text-[rgba(245,245,243,.4)]">12 months of guessing</div>
        </div>

        <div className="rounded-[14px] border border-[#3D6BFF] bg-[rgba(255,255,255,.02)] px-6 py-[26px]">
          <div className="font-mono text-[11px] tracking-[0.1em] text-[#5B8CFF] uppercase">On LiquidBrain*</div>
          <div className="mt-3.5 font-mono text-[clamp(1.6rem,3.2vw,2.2rem)] leading-[1.05] font-semibold tracking-[-0.03em] text-[#5B8CFF]">{lbPrice}</div>
          <p className="mt-3 min-h-[3em] text-[0.95rem] leading-[1.5] text-[rgba(245,245,243,.55)]">Every month. Guaranteed. Unlimited tokens, unlimited context.</p>
          <div className="mt-[22px] flex h-[72px] items-end gap-[5px]" aria-hidden="true">
            {Array.from({ length: 12 }).map((_, i) => (
              <span key={i} title={lbPrice} className="h-[42%] flex-1 rounded-t-[3px] bg-[#3D6BFF]" />
            ))}
          </div>
          <div className="mt-3 text-center font-mono text-[11px] tracking-[0.04em] text-[rgba(245,245,243,.4)]">12 months of planning</div>
        </div>
      </div>
    </>
  )
}
